import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';

import services from '@C/DipReading/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { FuelList, DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'Date',
    key: 'invoice_date',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Invoice number',
    key: 'invoice_number',
  },
  {
    name: 'Supplier Name',
    key: 'all',
    formatter(props) {
      return (
        <>
          {props.vendor_first_name} {props.vendor_last_name}
        </>
      );
    },
  },
  {
    name: 'Product',
    key: 'product',
  },
  {
    name: 'Quantity',
    key: 'total_quantity',
  },
  {
    name: 'Amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.base_amount)}</>;
    },
  },
  {
    name: 'Discount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.discount)}</>;
    },
  },
  {
    name: 'VAT',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.vat)}</>;
    },
  },
  {
    name: 'Additional VAT',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.additional_vat)}</>;
    },
  },
  {
    name: 'Cess',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.cess)}</>;
    },
  },
  {
    name: 'Social sec cess',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.social_sec_cess)}</>;
    },
  },
  {
    name: 'Reverse dealer commission',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.reverse_dealer_commission)}</>;
    },
  },
  {
    name: 'Recovery for LFR/SSLF',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.recovery_for_lfr_sslf)}</>;
    },
  },
  {
    name: 'TCS Amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.tcs_amount)}</>;
    },
  },
  {
    name: 'Total amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.amount)}</>;
    },
  },
  {
    name: 'Notes',
    key: 'notes',
  },
];

const enabledActions = [
  {
    action: 'Edit',
    roles: ['Site Admin', 'Dealer'],
  },
  {
    action: 'Delete',
    roles: ['Site Admin', 'Dealer'],
  },
];

class FuelPurchaseList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      product_id: '',
      tank_id: '',
      invoice_number: '',
      fuelPurchaseList: [],
      limit: 20,
      offset: 1,
      count: 0,
      selectedId: '',
      showModal: false,
    };

    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getFuelPurchase();
  }

  getFuelPurchase = () => {
    services
      .getFuelPurchase(this.state)
      .then((response) => {
        this.setState({
          fuelPurchaseList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e.value });
  };
  handleTankChange = (e) => {
    this.setState({ tank_id: e.value });
  };
  handleLimitChange = (e) => {
    this.setState({ limit: e.target.value });
  };
  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getFuelPurchase();
    });
  };
  editItem = (selectedId) => {
    this.setState({ selectedId: selectedId, showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  handleInvoiceNumberChange = (e) => {
    this.setState({ invoice_number: e.target.value });
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getFuelPurchase();
      },
    );
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm transaction deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader(1);
    axios
      .delete(
        `${process.env.API_URL}/bunk/fuel-purchase/?invoice_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Transaction deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getFuelPurchase();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_id: '',
        tank_id: '',
        loading: false,
        limit: 20,
        offset: 1,
        count: 0,
        invoice_number: '',
      },
      function () {
        //this.getFuelPurchase();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getFuelPurchase();
    });
  };

  render() {
    const { fuelPurchaseList } = this.state;
    return (
      <section className="widget full-width  list-table">
        <header>
          <h3>Fuel Purchase List</h3>
        </header>
        <main className="list-content">
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group with-icon">
                <label>Results to display - (Total: {this.state.count})</label>
                <form onSubmit={this.handleQuickSearch}>
                  <input
                    type="text"
                    value={this.state.limit}
                    onChange={this.handleLimitChange}
                    name="limit"
                    ref={this.limitInput}
                  />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group with-icon">
                <label>Invoice number:</label>
                <form onSubmit={this.handleQuickSearch}>
                  <input
                    type="text"
                    value={this.state.invoice_number}
                    onChange={this.handleInvoiceNumberChange}
                  />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={(dates) => {
                    this.setState({
                      start_date: dates[0],
                      end_date: dates[1],
                    });
                  }}
                  limit={6}
                />
              </div>
              <div className="filter-group">
                <label>Product:</label>
                <FuelList
                  onChange={this.handleProductChange}
                  value={this.state.product_id}
                />
              </div>

              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Apply filter
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={fuelPurchaseList}
                      offset={this.state.offset}
                      count={this.state.count}
                      limit={this.state.limit}
                      handlePagination={this.handlePagination}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      enabledActions={enabledActions}
                      exportOptions={{
                        fileName: `Fuel Purchase List - ${this.state.start_date} to ${this.state.end_date}.pdf`,
                        reportName: 'Fuel Purchase List',
                        reportDate: `Date - ${dayjs(
                          this.state.start_date,
                        ).format(
                          'D MMM YY',
                        )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                        reportTotal: `Total VAT -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['vat'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportQuantity: `Total quantity -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['total_quantity'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportSales: `Total additional VAT -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['additional_vat'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportTesting: `Total reverse dealer commission -  ${
                          fuelPurchaseList
                            .reduce(
                              (a, b) =>
                                a + (b['reverse_dealer_commission'] || 0),
                              0,
                            )
                            .toFixed(2) || 0
                        }`,
                        reportBowser: `Total recovery for LFR/SSLF -  ${
                          fuelPurchaseList
                            .reduce(
                              (a, b) => a + (b['recovery_for_lfr_sslf'] || 0),
                              0,
                            )
                            .toFixed(2) || 0
                        }`,
                        reportCustomerName: '',
                        reportGst: '',
                        reportOpeningBalance: `Total amount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['base_amount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportClosingBalance: `Total discount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['discount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportSaleTotal: `Total sale amount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['amount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportTCSTotal: `Total TCS amount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['tcs_amount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                      }}
                    />
                  </>
                );
              }
            })()}
            <div className="mini-summary">
              <ul>
                <li>
                  <span>Total amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['base_amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total discount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['discount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total VAT: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['vat'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total additional VAT: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['additional_vat'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total reverse dealer commission: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['reverse_dealer_commission'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total recovery for LFR/SSLF: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['recovery_for_lfr_sslf'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total TCS amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['tcs_amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total sale amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total quantity: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['total_quantity'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </section>
    );
  }
}

export { FuelPurchaseList };
